import i18n from "@/i18n";

const routes = {
  path: "/gamedata",
  name: "GameData",
  component: () =>
    import(
      /* webpackChunkName: "gamedata" */ "@/views/management/gamedata/Main"
    ),
  children: [
    {
      path: "gameview",
      alias: "",
      name: "GameDataView",
      component: () =>
        import(
          /* webpackChunkName: "gamedata" */ "@/views/management/gamedata/GameDataView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.game_data_set"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.game_data")],
        menu_num: 7,
        sub_menu_num: 72,
        location: "/gamedata/gameview",
      },
    },
    {
      path: "gamescore",
      name: "GameDataScoreBoard",
      component: () =>
        import(
          /* webpackChunkName: "gamedata" */ "@/views/management/gamedata/GameDataScoreBoard"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.scoreboard"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.game_data")],
        menu_num: 7,
        sub_menu_num: 72,
        location: "/gamedata/gameview",
      },
    },
    {
      path: "gameoneshot",
      name: "GameDataOneShot",
      component: () =>
        import(
          /* webpackChunkName: "gamedata" */ "@/views/management/gamedata/GameDataOneShot"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.oneshot"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.game_data")],
        menu_num: 7,
        sub_menu_num: 72,
        location: "/gamedata/gameview",
      },
    },
    {
      path: "gameinfo",
      name: "GameDataInfo",
      component: () =>
        import(
          /* webpackChunkName: "gamedata" */ "@/views/management/gamedata/GameDataInfo"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.gamedata"),
        step: [i18n.t("menu.admin.admin"), i18n.t("page.admin.game_data")],
        menu_num: 7,
        sub_menu_num: 72,
        location: "/gamedata/gameview",
      },
    },
    {
      path: "gamedatacorrectionlist",
      name: "GameDataCorrectionList",
      component: () =>
        import(
          /* webpackChunkName: "gamedata" */ "@/views/management/gamedata/GameDataCorrectionList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.data_correction"),
        step: [
          i18n.t("menu.admin.admin"),
          i18n.t("menu.admin.data_correction"),
        ],
        menu_num: 7,
        sub_menu_num: 76,
        location: "/gamedata/gamedatacorrectionlist",
      },
    },
  ],
};

export default routes;
